// extracted by mini-css-extract-plugin
export default {"mt":"UserPolicyView_mt__jBdhN","cmt":"UserPolicyView_cmt__j4+Mo"};